
<!-- Индивидуальный расчет -->

<template>

	<setup_content v-if="active_step == 'individual'" title="Индивидуальный расчет">

        <template v-slot:buttons>
            <div class="d-flex justify-content-center mb-2" style="gap: .625rem;">
                <b-button variant="outline-primary-secondary" :disabled="! check()" v-on:click="() => cost_import()">
                    <span>Импорт</span><base-icon name="upload" size="md" />
                </b-button>
            </div>
        </template>

        <b-row class="mt-2" align-v="center">

            <b-col class="d-flex justify-content-end">Модель оценки КС</b-col>
            <b-col>

                <v-select :clearable="false" v-model="method_name" :options="method_names" clearSearchOnSelect required/>

            </b-col>

        </b-row>

        <b-overlay :show="wait">
            <myframe title="Импорт значений">

                <b-row align-v="center">

                    <b-col class="d-flex justify-content-end"><strong>Файл</strong></b-col>
                    <b-col>

                        <b-form-file v-model="fl" placeholder="Файл" v-on:input="load_file" accept=".xlsx">
    
                            <template v-slot:placeholder>
    
                                {{ fl_name }}
    
                            </template>
    
                        </b-form-file>

                    </b-col>

                </b-row>

                <b-row class="mt-2" align-v="center">

                    <b-col class="d-flex justify-content-end"><strong>Страница</strong></b-col>
                    <b-col>

                        <v-select class="mt-2" :clearable="false" :disabled="!fl" v-model="sheet" :options="wb.SheetNames" v-on:input="sheet_select" clearSearchOnSelect required/>

                    </b-col>

                </b-row>

            </myframe>
            <myframe title="Сопоставление характеристик">

                <b-row class="mt-2" align-v="center">

                    <b-col class="d-flex justify-content-end">Кадастровый номер<span class="element-row_must">*</span></b-col>
                    <b-col>
                        <v-select :clearable="false" :disabled="!(fl && sheet)" v-model="primary_attr_column" :options="columns" label="name" :reduce="obj => obj.id" clearSearchOnSelect required/>
                    </b-col>

                </b-row>

                <b-row class="mt-2" align-v="center">

                    <b-col class="d-flex justify-content-end">Кадастровая стоимость (руб.)<span class="element-row_must">*</span></b-col>
                    <b-col>
                        <v-select :clearable="false" :disabled="!(fl && sheet)" v-model="cost_column" :options="columns" label="name" :reduce="obj => obj.id" clearSearchOnSelect required/>
                    </b-col>

                </b-row>

                <b-row class="mt-2" align-v="center">

                    <b-col class="d-flex justify-content-end">УПКС<span class="element-row_must">*</span></b-col>
                    <b-col>
                        <v-select :clearable="false" :disabled="!(fl && sheet)" v-model="upks_column" :options="columns" label="name" :reduce="obj => obj.id" clearSearchOnSelect required/>
                    </b-col>

                </b-row>

            </myframe>
                
        </b-overlay>

	</setup_content>
	<setup_content v-else title="Расчет кадастровой стоимости">

		<biTable :data="rows" />

		<individual_details class="mt-2" :id="id"/>

	</setup_content>

</template>

<script>

import XLSX from "xlsx"
import api from "../../../../../api"
import main_tree from "../../../../../api/main_tree"
import myframe from "../setup_assets/frame"
import setup_content from "../setup_assets/content"
import individual_details from "./details"
import biTable from "../../../../widgets/bi-table"

export default
{
	props :
	{
		id : String,
		data : Object,
		active_step : String,
	},

	components :
	{
		myframe,
		setup_content,
		individual_details,
		biTable
	},

	data()
	{
		return {

			service : "cadastral_cost_evaluation",
			fl : null,
			wb : { SheetNames : [] },
			fl_name : null,
			sheet : null,
			columns : [],
			primary_attr_column : null,
			cost_column : null,
			upks_column : null,
			wait : false,
			method_name : null,
			method_names : [],

		}
	},

	mounted()
	{
		api.call(this, "cadastral_attrs", "get_by", { field : "key", value : "attrs.method_name" },
			response =>
			{
				this.method_names = [ "Иное", ...api.sort_strings(response.data.reference.values) ]
				this.method_name = this.method_names[0]
			})
	},

	computed :
	{
		rows()
		{
			return [
				{ title : "Наименование файла", value : this.data.fname },
				{ title : "Всего обработано объектов", value : this.data.count },
				{ title : "из них успешно", value : this.data.success_count },
				{ title : "из них с ошибкой", value : this.data.error_count }
			]
		}
	},

	methods :
	{
		refresh()
		{
		},

		load_file(fl)
		{
			if(fl)
			{
				const reader = new FileReader()

				this.fl_name = fl.name
			
				reader.onload =
					event =>
					{
						const raw = event.target.result
						
						this.wb = XLSX.read(raw, { type : "binary", sheetRows : 30 })

						this.sheet = null
						this.columns = []
						this.primary_attr_column = null
						this.cost_column = null
						this.upks_column = null

						if(this.wb.SheetNames.length)
							this.sheet_select(this.wb.SheetNames[0])

						this.wait = false
					}

				this.wait = true
				reader.readAsBinaryString(fl)
			}
		},

		sheet_select(sheet)
		{
			this.sheet = sheet
			this.columns = []
			this.primary_attr_column = null
			this.cost_column = null
			this.upks_column = null

			const ws = this.wb.Sheets[sheet]
			const range = XLSX.utils.decode_range(ws["!ref"])

			for(var col = range.s.c; col <= range.e.c; col++)
			{
				var cell = ws[XLSX.utils.encode_cell({ c : col, r : 0 })]

				if(cell)
					this.columns.push({ name : cell.v, id : col + 1 })
			}
		},

		check()
		{
			return this.primary_attr_column != null && this.cost_column != null && this.upks_column != null && this.method_name != null
		},

		cost_import()
		{
			var reader = new FileReader()

			reader.onload =
				fl =>
				{
					api.upload_file(this, fl, this.fl.name, this.fl.name,
						response =>
						{
							var params = {

								id : this.id,
								file : response.id,
								sheet : this.sheet,
								method_name : this.method_name,
								cadastral_number_column : this.primary_attr_column,
								cost_column : this.cost_column,
								upks_column : this.upks_column,

							}

							this.wait = false

							api.call_long_operation(this, "Индивидуальный расчет запущен", "cadastral_groups", "import_cost", params,
								response =>
								{
									api.delete_file(this, params.file)
									api.open_response_url(response)

									this.fl = null
									this.fl_name = null
									this.wb = { SheetNames : [] }
									this.sheet = null
									this.columns = []
									this.primary_attr_column = null
									this.cost_column = null
									this.upks_column = null
									this.method_name = null

									this.$emit("need_refresh")

									main_tree.create(this)
										.then(() => {
											this.$emit("set_active_step", "individual_results")
										})
								},
								{ success_msg : "Импорт индивидуального расчета завершен" }
							)
						})
				}

			reader.readAsBinaryString(this.fl)
		},
	}
}

</script>
